<template>
  <div class="modal fade" id="myModal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" :style="`width:${modalWidth}px`" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body" :class="customBodyClass">
          <span v-html="message"></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning close-btn" data-dismiss="modal" @click="$emit('close')">{{ closeButtonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: null
    },
    customHide: {
      type: Boolean,
      default: false
    },
    modalWidth: {
      type: Number,
      default: 400
    },
    customBodyClass: {
      type: String,
      default: null
    },
    closeButtonText: {
      type: String,
      default: 'OK'
    }
  },
  mounted () {
    $('#myModal').modal('show')
    if (this.customHide) {
      $('#myModal').on('hidden.bs.modal', (e) => {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      })
    }
  },
  beforeDestroy () {
    setTimeout(() => {
      $('body').attr({
        style: null
      })
    }, 700)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalAlert.vue